import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Chart } from "chart.js";

export default function ScanRatingChart({
    title,
    subtitle,
    score,
    segments,
    onViewReport,
    onChartClick,
    reportLoading = false,
}) {
    const { t } = useTranslation();
    const canvasRef = useRef(null);
    const chartRef = useRef(null);

    useEffect(() => {
        if (!canvasRef.current) return;

        chartRef.current?.destroy();

        chartRef.current = new Chart(canvasRef.current, {
            type: "doughnut",
            data: {
                datasets: [
                    {
                        data: segments.map((s) => s.value),
                        backgroundColor: segments.map((s) => s.color),
                        borderWidth: 0,
                        spacing: 3,
                        borderRadius: 6,
                        cutout: "78%",
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: { enabled: false },
                },
            },
        });

        return () => chartRef.current?.destroy();
    }, [segments]);

    return (
        <div className="scan-charts-content">
            <div className="scan-charts-content-header">
                <div className="scan-charts-content-header-label">
                    <h3 className="scan-charts-content-header-label-title">
                        {t(title)}
                    </h3>
                    <p className="scan-charts-content-header-label-subtitle">
                        {t(subtitle)}
                    </p>
                </div>

                {typeof onViewReport === "function" && <button
                    type="button"
                    className="scan-charts-content-header-button"
                    onClick={onViewReport}
                    disabled={reportLoading}
                    aria-busy={reportLoading}
                >
                    {t("View report")}
                </button>}
            </div>

            {/* C'est CE conteneur qui déclenche la popup globale pour ce composant ! */}
            <div 
                className="scan-charts-container scan-charts-container--rating"
                onClick={onChartClick}
                style={{ cursor: onChartClick ? 'pointer' : 'default' }}
                role={onChartClick ? "button" : undefined}
                tabIndex={onChartClick ? 0 : undefined}
            >
                <div style={{ position: "relative", width: 160, height: 160, margin: "0 auto" }}>
                    <canvas ref={canvasRef} />

                    <div
                        style={{
                            position: "absolute", inset: 0, display: "flex", flexDirection: "column",
                            alignItems: "center", justifyContent: "center", pointerEvents: "none",
                        }}
                    >
                        <span style={{ fontSize: 30, fontWeight: 800 }}>{score}</span>
                        <span style={{ fontSize: 11, fontWeight: 600 }}>/ 100</span>
                        <span style={{ fontSize: 10, textAlign: "center", maxWidth: 90, marginTop: 3 }}>
                            {t("Security Score")}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}